import { Fragment } from "react";
import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";

export interface Option {
  id: number | string;
  label: string;
}

interface ButtonRadioProps<T> {
  value: T | undefined;
  options: T[];
  onChange: (option: T) => void;
}

export const ButtonRadio = <TOption extends Option>({
  value,
  options,
  onChange,
}: ButtonRadioProps<TOption>) => {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      className="flex gap-3 items-center w-full font-medium text-normal"
    >
      {options.map((option) => (
        <RadioGroup.Option as={Fragment} value={option} key={option.id}>
          {({ checked }) => {            
           return (
            <div
              style={{ 
                border: '1px solid #E5E5E5',
                borderRadius: '50px',
              }}
              className={classNames(
                "p-1.5 text-center grow cursor-pointer hover:bg-gray-100 focus:ring-0",
                {
                  "bg-primary-100 text-white hover:bg-[#01172e] bg-[#002c5a] ":
                   checked || option.id === value?.id,
                }
              )}
            >
              {option.label}
            </div>
          )}}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};
